module.exports = __webpack_public_path__ + "static/media/loading.5fc77115.svg";


//////////////////
// WEBPACK FOOTER
// ./src/FO/resources/img/loading.svg
// module id = 773
// module chunks = 0